/**
 * Full-page navigation to another origin (OAuth redirects back to Stripe, Claude, ChatGPT…).
 * A one-line wrapper so screens can be unit-tested: jsdom cannot implement
 * `window.location.assign`, so tests mock this module instead of the browser.
 */
export function assignLocation(url) {
  window.location.assign(url);
}

export default assignLocation;
